// Package imports
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Grid, Box, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

// Custom imports
import { joinByKeys } from "../../../Js/Common";

// Component
function LearnerReportCard(props) {
  //State
  const [colorCode, setColorCode] = useState("#DB8829");
  const { siteConfig } = useSelector((state) => state.defs);

  useEffect(() => {
    if (
      props.reportData.total_active_assignments != null &&
      props.reportData.total_active_attempted_assignment == null
    ) {
      setColorCode("#ff0000");
    } else {
      setColorCode("#DB8829");
    }
  }, [props.reportData]);

  // JSX template
  return (
    <Box
      sx={{ borderRadius: 5, border: 1, borderColor: "#D9D9D9", boxShadow: 1,       
        background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%)",
                  }}
    >
      <Typography
        sx={{
          color: "#5f5600ff",
          fontWeight: "900",
          fontSize: "1.2rem",
          textAlign: "left",
          marginLeft: 1.5,
          marginTop: 2,
          "@media (min-width: 1636px)": { fontSize: "2rem" },
        }}
      >
        {joinByKeys(props.reportData.name, ["firstname", "lastname"], " ")}
      </Typography>
      <Grid
        container
        sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          mx: 2,
        }}
      >
        <Grid item>
          <Grid sx={{ marginBottom: 0.2 }}>
            <Typography
              sx={{
                color: "#5f5600ff",
                textAlign: "left",
                textTransform: "uppercase",
                fontWeight: "600",
                fontSize: "0.7rem",
                "@media (min-width: 1636px)": { fontSize: "1.2rem" },
              }}
            >
              Active Assignment:{" "}
              {props.reportData.total_active_assignments || 0}
            </Typography>
          </Grid>
          <Grid>
            <Typography
              sx={{
                color: colorCode,
                textAlign: "left",
                textTransform: "uppercase",
                fontWeight: "600",
                fontSize: "0.7rem",
                "@media (min-width: 1636px)": { fontSize: "1.2rem" },
              }}
            >
              Active Attempted assignments:{" "}
              {props.reportData.total_active_attempted_assignment || 0}
            </Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid sx={{ marginBottom: 0.2, pr: 4 }}>
            <Typography
              sx={{
                color: "#5f5600ff",
                textAlign: "left",
                textTransform: "uppercase",
                fontWeight: "600",
                fontSize: "0.7rem",
                "@media (min-width: 1636px)": { fontSize: "1.2rem" },
              }}
            >
              Selected duration:{" "}
              {props.reportData.attempted_in_selected_duration || 0}
            </Typography>
          </Grid>
          {!siteConfig?.customer?.addOnInfo?.isEstimatedDuration && (
            <Grid>
              <Typography
                sx={{
                  color: "#DB8829",
                  textAlign: "left",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  fontSize: "0.7rem",
                  "@media (min-width: 1636px)": { fontSize: "1.2rem" },
                }}
              >
                Usage(HH:MM):{" "}
                {props.reportData.selected_duration_usages || "00:00"}
              </Typography>
            </Grid>
          )}
        </Grid>
        <Grid
          container
          sx={{
            mt: 1,
            mb: 1,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* <Grid item>
            <Typography
              sx={{
                color: "#3a3a3aff",
                fontSize: "0.7rem",
                fontWeight: "600",
                "@media (min-width: 1636px)": { fontSize: "1.2rem" },
              }}
            >
              View
            </Typography>
          </Grid>
          <Grid item sx={{ pr: 3 }}>
            <IconButton
              aria-label="Go"
              size="small"
              sx={{ borderRadius: "50%", color: "primary.main", padding: 0.5 }}
            >
              <NavigateNextIcon
                fontSize="inherit"
                sx={{
                  fontSize: "1.5rem",
                  "@media (min-width: 1636px)": { fontSize: "2rem" },
                }}
              />
            </IconButton>
          </Grid> */}
        </Grid>
      </Grid>
    </Box>
  );
}

export default LearnerReportCard;
